import { render, staticRenderFns } from "./ProposalStore.vue?vue&type=template&id=4891b8d3&scoped=true"
import script from "./ProposalStore.vue?vue&type=script&lang=js"
export * from "./ProposalStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4891b8d3",
  null
  
)

export default component.exports